// @flow

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { Form, FormGroup, Label } from "@components";
import { reduxForm, Field } from "redux-form";
import type { FormProps } from "redux-form";
import { DatePickerFormWrapper } from "@components/form";
import type { AddNotificationData } from "@modules/shared/reducer/employee-notifications/types";
import config from "@config";
type OwnProps = $Exact<{
  notificationData: AddNotificationData,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class StepDateFields extends React.Component<Props> {
  componentDidMount() {
    if (!this.props.notificationData || !this.props.notificationData.notificationDates) {
      return;
    }

    this.props.initialize({
      activeFrom: this.props.notificationData.notificationDates.activeFrom,
      activeTo: this.props.notificationData.notificationDates.activeTo,
    });
  }

  render() {
    return (
      <Form className="d-flex flex-column">
        <FormGroup>
          <Label for="activeFrom">{this.props.t("DATE_FROM")}</Label>
          <Field
            name="activeFrom"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, id: "activeFrom" }}
          />
        </FormGroup>
        <FormGroup>
          <Label for="activeTo">{this.props.t("DATE_TO")}</Label>
          <Field
            name="activeTo"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, endDate: true, id: "activeTo" }}
          />
        </FormGroup>
      </Form>
    );
  }
}

export default compose(
  reduxForm({
    form: "notification-step-date-fields",
  }),
  localize(),
)(StepDateFields);
